const cards = [
  {
    title: '台北娜娜直播间翻车名场面',
    desc: '台北娜娜最新直播中突发状况，网友：笑到肚子疼！速看完整回顾。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20pink%20abstract%20art%2C%20soft%20flowing%20gradients%2C%20entertainment%20news%20card%20style%2C%20modern%20youth%20culture%2C%20vibrant%20warm%20tones%2C%20clean%20editorial%20layout&width=600&height=400&seq=card-01&orientation=landscape',
    alt: '台北娜娜直播间翻车名场面',
    date: '2小时前',
    tag: '热梗合集',
  },
  {
    title: '玩偶姐姐最新回应引爆全网',
    desc: '玩偶姐姐首次正面回应争议话题，吃瓜娱乐现场独家整理事件全貌。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20peach%20abstract%20composition%2C%20dynamic%20soft%20shapes%2C%20news%20highlight%20style%2C%20modern%20editorial%20design%2C%20clean%20gradient%20background%2C%20warm%20energetic%20vibe&width=600&height=400&seq=card-02&orientation=landscape',
    alt: '玩偶姐姐最新回应引爆全网',
    date: '5小时前',
    tag: '热门追踪',
  },
  {
    title: '莫里秀轻量版吃瓜短视频上线',
    desc: '莫里秀全新轻量版吃瓜短视频专区上线，搞笑吃瓜瞬间一次看够。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20rose%20coral%20abstract%20geometric%20art%2C%20playful%20modern%20design%2C%20entertainment%20card%20theme%2C%20soft%20vibrant%20colors%2C%20clean%20contemporary%20layout&width=600&height=400&seq=card-03&orientation=landscape',
    alt: '莫里秀轻量版吃瓜短视频上线',
    date: '8小时前',
    tag: '轻量版精选',
  },
  {
    title: '吃瓜真人秀片段高能合集',
    desc: '本周吃瓜真人秀最精彩片段盘点，网友直呼：每一秒都是名场面。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20orange%20coral%20fluid%20abstract%20art%2C%20bubbly%20dynamic%20composition%2C%20entertainment%20highlight%20style%2C%20soft%20gradients%2C%20modern%20vibrant%20aesthetic%2C%20clean%20background&width=600&height=400&seq=card-04&orientation=landscape',
    alt: '吃瓜真人秀片段高能合集',
    date: '12小时前',
    tag: '真人秀',
  },
  {
    title: '网红直播翻车搞笑吃瓜瞬间',
    desc: '整理本月搞笑吃瓜瞬间TOP20，网红直播翻车名场面一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20peach%20pink%20abstract%20art%2C%20playful%20flowing%20shapes%2C%20funny%20entertainment%20theme%2C%20soft%20glowing%20highlights%2C%20modern%20clean%20composition%2C%20vibrant%20warm%20tones&width=600&height=400&seq=card-05&orientation=landscape',
    alt: '网红直播翻车搞笑吃瓜瞬间',
    date: '1天前',
    tag: '翻车现场',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          吃瓜精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          今日不容错过的热门吃瓜内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-100 rounded-2xl border border-background-200/80 overflow-hidden hover:border-primary-200 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`${i === 0 ? 'flex flex-col sm:flex-row' : 'flex flex-col'}`}>
                <div className={`relative overflow-hidden flex-shrink-0 ${i === 0 ? 'sm:w-[55%] aspect-video sm:aspect-auto sm:h-full' : 'w-full aspect-[3/2]'}`}>
                  <img
                    src={card.img}
                    alt={card.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className={`p-4 md:p-5 flex flex-col justify-center ${i === 0 ? 'sm:flex-1' : ''}`}>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {card.desc}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {card.date}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-share-forward-line"></i> 分享
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}